// extracted by mini-css-extract-plugin
export default {"margin":"PageNotFound_margin__V8EbH"};